import React, { useState, useEffect } from 'react';
import CommentCard from './CommentCard';
import { Form, Row, Col } from 'react-bootstrap';

function CommentList({ comments }) {
  const [sortedComments, setSortedComments] = useState([]);
  const [sortOrder, setSortOrder] = useState('date-desc');
  
  useEffect(() => {
    sortComments(sortOrder);
  }, [comments, sortOrder]);
  
  const sortComments = (order) => {
    let sorted = [...comments];
    
    switch(order) {
      case 'date-asc':
        sorted.sort((a, b) => a.participation_race.localeCompare(b.participation_race));
        break;
      case 'date-desc':
        sorted.sort((a, b) => b.participation_race.localeCompare(a.participation_race));
        break;
      case 'rate-asc':
        sorted.sort((a, b) => a.rate - b.rate);
        break;
      case 'rate-desc':
        sorted.sort((a, b) => b.rate - a.rate);
        break;
      case 'result-asc':
        sorted.sort((a, b) => {
          if (!a.result) return 1;
          if (!b.result) return -1;
          return a.result - b.result;
        });
        break;
      case 'result-desc':
        sorted.sort((a, b) => {
          if (!a.result) return 1;
          if (!b.result) return -1;
          return b.result - a.result;
        });
        break;
      default:
        break;
    }
    
    setSortedComments(sorted);
  };

  return (
    <div className="comment-list">
      <Row className="mb-3">
        <Col md={4} lg={3}>
          <Form.Group>
            <Form.Label>並び替え</Form.Label>
            <Form.Select 
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
            >
              <option value="date-desc">日付（新しい順）</option>
              <option value="date-asc">日付（古い順）</option>
              <option value="rate-desc">自信度（高い順）</option>
              <option value="rate-asc">自信度（低い順）</option>
              <option value="result-asc">結果（良い順）</option>
              <option value="result-desc">結果（悪い順）</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      
      <Row xs={1} md={2} lg={3} className="g-4">
        {sortedComments.map((comment, index) => (
          <Col key={index}>
            <CommentCard comment={comment} />
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default CommentList;